
//create gallery angular Module
angular.module('gallery', []);


// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/app.js